<template>
    <vue-good-table
        v-bind="componentOptions"
        :columns="columns"
        :rows="rows"
        class="shadow-sm"
    >
        <div
            v-if="$slots['table-actions'] || $scopedSlots['table-actions']"
            slot="table-actions"
            class="mb-3"
        >
            <slot name="table-actions"/>
        </div>

        <div slot="emptystate" class="text-center">
            <b-spinner v-if="loading" variant="primary"></b-spinner>
            <span v-else>{{ $t('GENERIC.NORECORD') }}</span>
        </div>

        <template slot="table-row" slot-scope="props">
            <b-row v-if="props.column.field == 'button'" class="mr-1">
                <b-col class="p-0">
                    <a
                        @click.stop="$emit('edit', props.row)"
                        v-b-tooltip.hover
                        class="btn p-1 text-decoration-none"
                        title="Editar"
                    >
                        <i class="i-Pen-5 text-25 text-success"></i>
                        {{ props.row.button }}
                    </a>
                </b-col>
                <b-col cols="3" class="text-center p-0">
                    <b-button
                        v-if="props.row.active"
                        variant="outline-info"
                        size="sm"
                        @click.stop="$emit('inactivate', props.row)"
                        title="Inativar"
                    >
                        Ativo
                    </b-button>
                    <b-button
                        v-else
                        variant="outline-warning"
                        size="sm"
                        @click.stop="$emit('activate', props.row)"
                        title="Ativar"
                    >
                        Inativo
                    </b-button>
                </b-col>
            </b-row>
            <b-row v-else-if="props.column.field == 'emoji'">
                <b-col>
                    <response-emoji
                        :response="props.row.response"
                        :hasText="true"
                        class="p-0"
                        size="20px"
                    />
                </b-col>
            </b-row>
            <b-row v-else-if="props.column.field == 'visualize'">
                <b-col>
                    <b-button
                        variant="outline-primary"
                        :to="`/happiness/reports/feedbacks/${props.row.uid}`"
                    >
                        Visualizar Respostas
                    </b-button>
                </b-col>
            </b-row>
        </template>

        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.label == 'Incrível'">
                <response-emoji
                    :response="3"
                    :hasText="true"
                    class="p-0"
                    size="20px"
                />
            </span>
            <span v-else-if="props.column.label == 'Feliz'">
                <response-emoji
                    :response="2"
                    :hasText="true"
                    class="p-0"
                    size="20px"
                />
            </span>
            <span v-else-if="props.column.label == 'Regular'">
                <response-emoji
                    :response="1"
                    :hasText="true"
                    class="p-0"
                    size="20px"
                />
            </span>
            <span v-else-if="props.column.label == 'Infeliz'">
                <response-emoji
                    :response="0"
                    :hasText="true"
                    class="p-0"
                    size="20px"
                />
            </span>
            <span v-else>
                {{props.column.label}}
            </span>
        </template>
    </vue-good-table>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
export default {
    components: {
        VueGoodTable,
        ResponseEmoji: () => import('@/components/Emojis/ResponseEmoji'),
    },
    props: {
        columns: {
            type: Array,
            default: () => [],
        },
        rows: {
            type: Array,
            default: () => [],
        },
        options: {
            type: Object,
            default: () => ({}),
        },
        paginationOptions: {
            type: Object,
            default: () => ({}),
        },
        selectOptions: {
            type: Object,
            default: () => ({}),
        },
        loading: {
            type: Boolean,
            default: () => true,
        },
    },
    computed: {
        componentOptions () {
            return {
                lineNumbers: false,
                searchOptions: {
                    enabled: true,
                    placeholder: 'Digite para pesquisar!',
                },
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    nextLabel: 'Próxima',
                    prevLabel: 'Anterior',
                    rowsPerPageLabel: 'Linhas por página',
                    ofLabel: 'de',
                    pageLabel: 'página',
                    allLabel: 'Todas',
                    perPage: 10,
                    ...this.paginationOptions,
                },
                styleClass: 'tableOne vgt-table',
                selectOptions: {
                    enabled: true,
                    selectionInfoClass: 'table-alert__box',
                    selectionText: 'Linha(s) selecionada(s)',
                    clearSelectionText: 'deselecionar',
                    ...this.selectOptions,
                },
                ...this.options,
            }
        },
    },
}
</script>

<style lang="scss">
.vgt-global-search {
    background: #fff;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border-top: 1px solid #fff;
    border-right: 1px solid #fff;
    border-left: 1px solid #fff;
}

.vgt-table {
    thead th {
        background: #f5f5f5;
        border-left: 1px solid #fff;
        border-right: 1px solid #fff;
    }

    tbody {
        td {
            border-left: 1px solid #fff;
            border-right: 1px solid #fff;
            padding: .65em;
            vertical-align: middle;
        }

        tr {
            &:nth-child(even) {
                background: #f5f5f5;
            }
            &:hover {
                background: #e9e8e8;
            }
        }
    }
}

.vgt-wrap__footer {
    background: #fff;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    margin-bottom: 0.75rem;
    border-top: 0;
    border-left: 1px solid #fff;
    border-bottom: 1px solid #fff;
    border-right: 1px solid #fff;
}

.vgt-global-search__input {
    padding: 0.25rem 0.25rem 0.25rem 45px;
}

.vgt-global-search__actions {
    padding: 0.25rem 0.75rem 0.25rem 0.25rem;
}
.text-warning-600 {
    color: darken(#ffc107, 10);
}

.list-actions {
    display: flex;
    justify-content: flex-end;
}
</style>
